import React from 'react';

import { useIntl } from 'react-intl';

import ConfirmDialog from 'components/confirm-dialog';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useAuthContext } from 'state/auth';
import { ModalAuthScreen } from 'state/auth/types';
import { routes } from 'utils/routing';

interface IExistingModalDialogProps {
  showDialog: boolean;
  dismiss: () => void;
}

const ExistingEmailDialog: React.FC<React.PropsWithChildren<IExistingModalDialogProps>> = ({
  showDialog,
  dismiss,
}) => {
  const { formatMessage } = useIntl();
  const { navigate } = useNavigation();
  const { setModalAuthState, modalAuthIsOpen } = useAuthContext();

  return (
    <ConfirmDialog
      showDialog={showDialog}
      body={formatMessage({ id: 'logInWithExistingEmail' })}
      confirmLabel={formatMessage({ id: 'logIn' })}
      heading={formatMessage({ id: 'welcomeBack' })}
      onCancel={dismiss}
      onConfirm={() => {
        dismiss();
        if (modalAuthIsOpen) {
          setModalAuthState({ screen: ModalAuthScreen.SIGN_IN });
          return;
        }

        navigate(routes.signUp, {
          state: {
            attemptedSignUpWithExistingEmail: true,
            activeRouteIsSignIn: true,
          },
        });
      }}
      onDismiss={dismiss}
      modalAppearanceEventMessage="Email exists sign in prompt modal"
    />
  );
};

export default ExistingEmailDialog;
